<template>
    <div class="selections-section">
        <div class="header">Τύπος Εργασίας Βλάβης</div>
        <v-checkbox
            v-model="selections.earthworkOnPipe"
            label="Χωματουργική εργασία στο πολυσωλήνιο ή σε μεμονωμένο σωληνίσκο"
            color="blue"
            hide-details
            class="bold-label"
            :readonly="readOnly"
        ></v-checkbox>
        <v-checkbox
            v-model="selections.restoreEarthwork"
            label="Επαναφορά χωματουργικών εργασιών"
            color="blue"
            hide-details
            class="bold-label"
            :readonly="readOnly"
        ></v-checkbox>
        <v-checkbox
            v-model="selections.malfunctionCab"
            label="Βλάβη από CAB σε BCP ή BEP με αντικατάσταση KOI"
            color="blue"
            hide-details
            class="bold-label"
            :readonly="readOnly"
        ></v-checkbox>
        <v-checkbox
            v-model="selections.malfunctionBcpBep"
            label="Βλάβη BCP‑BEP με αντικατάσταση KOI Περιλαμβάνοντα"
            color="blue"
            hide-details
            class="bold-label"
            :readonly="readOnly"
        ></v-checkbox>
        <v-checkbox
            v-model="selections.malfunctionBepFb"
            label="Βλάβη BEP‑FB (Περιλαμβάνονται οι τερματισμοί‑συγκολλήσεις & αποτοποθήτη)"
            color="blue"
            hide-details
            class="bold-label"
            :readonly="readOnly"
        ></v-checkbox>
        <v-checkbox
            v-model="selections.koiRemoval"
            label="Αποτοποθέτηση KOI μόνο σε απόσταση BCP‑BEP"
            color="blue"
            hide-details
            class="bold-label"
            :readonly="readOnly"
        ></v-checkbox>
        <v-checkbox
            v-model="selections.malfunctionOnAnyTerminal"
            label="Βλάβη σε οποιαδήποτε τερματική διάταξη (CAB‑BCP‑BEP‑FB) χωρίς αντικατάσταση KOI / Περιλαμβάνονται τερμ"
            color="blue"
            hide-details
            class="bold-label"
            :readonly="readOnly"
        ></v-checkbox>
        <v-checkbox
            v-model="selections.malfunctionOnLastDrop"
            label="Βλάβη σε Last drop από FB‑OTO ή BEP‑OTO"
            color="blue"
            hide-details
            class="bold-label"
            :readonly="readOnly"
        ></v-checkbox>
        <v-checkbox
            v-model="selections.splitterOnCab"
            label="Splitter σε CAB"
            color="blue"
            hide-details
            class="bold-label"
            :readonly="readOnly"
        ></v-checkbox>
        <v-checkbox
            v-model="selections.fiberCleaning"
            label="Κουμπώματα‑πιασμένη ή καθαρισμός ίνας (τροποποίηση διασυνδέσεων)"
            color="blue"
            hide-details
            class="bold-label"
            :readonly="readOnly"
        ></v-checkbox>
        <v-checkbox
            v-model="selections.splitterOnBcpBep"
            label="Splitter σε BCP ή BEP"
            color="blue"
            hide-details
            class="bold-label"
            :readonly="readOnly"
        ></v-checkbox>
    </div>
</template>
<script>
    export default {
        watch: {
            selections: {
                handler(newVal, oldVal) {
                    this.$emit('on-selection', newVal)
                },
                deep: true
            },
            alreadySelected: {
                handler(newVal, oldVal) {
                    console.log(newVal)
                    this.selections = newVal || {}
                },
                immediate: true
            }
        },
        props: {
            readOnly: {
                type: Boolean,
                required: false,
                default: () => { return true }
            },
            alreadySelected: {
                type: Object,
                required: true
            }
        },
        data() {
            return {
                selections: {}
            }
        }
    }
</script>
<style scoped>
.selections-section {
    border: solid 1px var(--cards-and-tables-text-color);
    padding: 1rem;
    border-radius: 5px;
    margin-bottom: 0.5rem;
    width: 100%;
}
.header {
    width: 100%;
    font-size: 1.2rem;
    text-align: center;
}
</style>
<style>
.bold-label .v-label {
  font-weight: bold;
}
</style>
